import translations from '../../utils/language/translations.json'
import { useTranslation } from 'react-i18next';

function LoadMoreBar({ total, shown, onMore, disabled, stepIndex,SHOW_MORE_STEPS }) {
  const { i18n } = useTranslation();
  const t = (key) => translations.CardGrid[key][i18n.language];

  if (shown >= total) return null; // nothing left to load

  const remaining = total - shown;

  return (
    <div className="pagination-controls flex-h" style={{ justifyContent: "center", paddingBottom: 0 }}>
      <button onClick={onMore} className="pagination-button">
        {t('Show more')} ({Math.min(remaining,  SHOW_MORE_STEPS[Math.min(stepIndex, SHOW_MORE_STEPS.length-1)])})
      </button>
      <span style={{ marginLeft: 12, opacity: .75, fontSize: 12 }}>
        {remaining} {t('remaining')}
      </span>
    </div>
  );
}

export default LoadMoreBar;
